import React from 'react'
import { Avatar, Box, Typography } from '@mui/material'

import { useChatData } from 'components/contexts/ChatContext'
import useInnovaAuth from 'components/common/hooks/useInnovaAuth'
import useInnovaTheme from 'components/common/hooks/useInnovaTheme'
import { getUserNameFromEmail, getUserNameInitials } from 'utils/chatFunctions'

const getOtherMembers = (members, currentUser) =>
  Array.isArray(members) ? members.filter((member) => member !== currentUser) : []

const ConversationHeader = () => {
  const { chat } = useChatData()
  const { user } = useInnovaAuth()
  const { getGrayColor, getTextColor, theme } = useInnovaTheme()
  const members = getOtherMembers(chat.selectedChatRoom?.members, user?.name)
  const title = members.length ? members.map(getUserNameFromEmail).join(', ') : 'Select a conversation'
  const avatarColors =
    theme === 'dark'
      ? { bgcolor: '#244b68', borderColor: '#315f80', color: '#f5f9fc' }
      : { bgcolor: '#d7e7f5', borderColor: '#bfd6e9', color: '#16324f' }

  return (
    <Box
      sx={{
        alignItems: 'center',
        borderBottom: '1px solid',
        borderColor: getGrayColor(0.08),
        bgcolor: getGrayColor(0.02),
        display: 'flex',
        gap: 1.5,
        minHeight: '72px',
        px: 2,
      }}>
      <Avatar sx={{ border: '1px solid', ...avatarColors, fontSize: 13, height: 32, width: 32 }}>
        {members.length ? getUserNameInitials(members[0]) : '?'}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography noWrap variant='subtitle1' sx={{ color: getTextColor(), fontWeight: 700 }}>
          {title}
        </Typography>
        <Typography variant='body2' sx={{ color: getTextColor(), mt: 0.25, opacity: 0.55 }}>
          {members.length > 1
            ? `${members.length} participants`
            : members.length === 1
              ? 'Conversation'
              : 'No room selected'}
        </Typography>
      </Box>
    </Box>
  )
}

export default ConversationHeader
